import type { IEntityModel } from './base'
import type { ITask } from './task'

export interface IJitaiTaskConfig extends IEntityModel {
  taskId: string
  task?: ITask
  inactive: boolean
  current: boolean
  durationSeconds: number | null
  triggerLatencySeconds: number
  cooldownSeconds: number
  maxHourlyTriggerCount?: number | null
  maxDailyTriggerCount?: number | null
  jitaiConditionList?: IJitaiCondition[]
  dateTimeConditionList?: IJitaiDateTimeCondition[]
}

export enum JitaiTriggerDataType {
  GarminBbi = 'garminBbi',
  GarminSteps = 'garminSteps',
  GarminCalories = 'garminCalories',
  GarminAscnent = 'garminAscnent',
  GarminIntensityMinutes = 'garminIntensityMinutes',
  GarminHeartRate = 'garminHeartRate',
  GarminStress = 'garminStress',
  GarminPulseOx = 'garminPulseOx',
  GarminRespiration = 'garminRespiration',
  GarminAcc = 'garminAcc',
  GarminBodyBattery = 'garminBodyBattery',
}

export enum JitaiTriggerCondition {
  InstantValue = 'instantValue',
  Average = 'average',
  MaxDifferInRange = 'maxDifferInRange',
  CompareRatio = 'compareRatio',
}

export enum JitaiValueCondition {
  GreaterThan = 'gt',
  GreaterThanEqual = 'gte',
  LessThan = 'lt',
  LessThanEqual = 'lte',
  EqualTo = 'eq',
  NotEqualTo = 'ne',
}

export interface IJitaiCondition extends IEntityModel {
  jitaiConfigId: string
  jitaiConfig?: IJitaiTaskConfig
  inactive: boolean
  dataType: JitaiTriggerDataType
  triggerCondition: JitaiTriggerCondition
  valueCondition: JitaiValueCondition
  targetValue: number
  windowSeconds: number | null
  compareGreaterTaget: number | null
  minDataCountCriteria: number | null
}

export interface IJitaiDateTimeCondition extends IEntityModel {
  jitaiConfigId: string
  jitaiConfig?: IJitaiTaskConfig
  startTime: string | null
  endTime: string | null
  mon: boolean
  tue: boolean
  wed: boolean
  thu: boolean
  fri: boolean
  sat: boolean
  sun: boolean
}
